import { Column } from "../../cms/objects/column";
import {
    LockableFareParameterFilters,
    LockableFareParameterForm,
    LockableFareParameterListConfiguration,
    LockableFareParameterListCriteria,
    LockableFareParameterLocalization,
} from "../objects/lockableFareParameter";

export const LOCKABLE_FARE_PARAMETER_MODULE = 'CIRCUIT_FUNNEL_LOCKABLE_FARE_PARAMETER';

// Cellule d'actions (suppression) en fin de rangée — largeur fixe, non redimensionnable.
export const PARAMETER_ACTIONS_COLUMN_WIDTH = 72;

export const LOCKABLE_FARE_PARAMETER_DEFAULT_COLUMNS: Column[] = [
    { label: 'name', field_name: 'NAME', checked: true, order_by: 'name', fixed_width: false, last_updated: false, width: null },
    { label: 'market', field_name: 'MARKET', checked: true, order_by: '', fixed_width: false, last_updated: false, width: null },
    { label: 'destinations', field_name: 'DESTINATIONS', checked: true, order_by: '', fixed_width: false, last_updated: false, width: null },
    { label: 'canal', field_name: 'CANAL', checked: true, order_by: '', fixed_width: false, last_updated: false, width: null },
    { label: 'active', field_name: 'ACTIVE', checked: true, order_by: '', fixed_width: false, last_updated: false, width: null },
    { label: 'duration', field_name: 'DURATION', checked: true, order_by: 'lockable_fare_duration_hours', fixed_width: true, last_updated: false, width: null },
    { label: 'max-amount', field_name: 'MAX_AMOUNT', checked: true, order_by: '', fixed_width: true, last_updated: false, width: null },
    { label: 'extension-active', field_name: 'EXTENSION_ACTIVE', checked: true, order_by: '', fixed_width: false, last_updated: false, width: null },
    { label: 'modified-date', field_name: 'MODIFIED_DATE', checked: true, order_by: 'modified_date', fixed_width: true, last_updated: false, width: null },
    { label: 'modified-by', field_name: 'MODIFIED_BY', checked: false, order_by: 'last_author__username', fixed_width: true, last_updated: false, width: null },
    { label: 'created-date', field_name: 'CREATED_DATE', checked: false, order_by: 'created_date', fixed_width: true, last_updated: false, width: null },
    { label: 'created-by', field_name: 'CREATED_BY', checked: false, order_by: 'creator__username', fixed_width: true, last_updated: false, width: null },
];

export const EMPTY_LOCKABLE_FARE_PARAMETER_LIST_CONFIGURATION: LockableFareParameterListConfiguration = {
    columns: LOCKABLE_FARE_PARAMETER_DEFAULT_COLUMNS,
    preferences: [],
};

export const LOCKABLE_FARE_PARAMETER_DATE_FILTER_FIELDS: (keyof LockableFareParameterFilters)[] = [
    'created_date_gte',
    'created_date_lte',
    'modified_date_gte',
    'modified_date_lte',
];

export const EMPTY_LOCKABLE_FARE_PARAMETER_FILTERS: LockableFareParameterFilters = {
    active: null,
    allow_apps: null,
    allow_cms: null,
    cms_id: null,
    cms_name: '',
    funnel_id: null,
    funnel_type: '',
    creator: '',
    last_author: '',
    period: 'CREATION',
    period_type: 0,
    created_date_gte: null,
    created_date_lte: null,
    modified_date_gte: null,
    modified_date_lte: null,
};

export const EMPTY_LOCKABLE_FARE_PARAMETER_LIST_CRITERIA: LockableFareParameterListCriteria = {
    limit: 25,
    page: 0,
    search: '',
    order: 'asc',
    order_by: '',
    filters: EMPTY_LOCKABLE_FARE_PARAMETER_FILTERS,
};

export const EMPTY_LOCKABLE_FARE_PARAMETER_LOCALIZATION: LockableFareParameterLocalization = {
    name: '',
    locale: 0,
};

export const EMPTY_LOCKABLE_FARE_PARAMETER_FORM: LockableFareParameterForm = {
    name: null,
    localization: [],
    market: null,
    destinations: [],
    lockable_fare_active: true,
    lockable_fare_duration_hours: 24,
    lockable_fare_max_amount: null,
    lockable_fare_nb_hours_notification_before_cancel: null,
    lockable_fare_active_extension: false,
    lockable_fare_extension_duration_hours: 24,
    cms: null,
    funnel: null,
    allow_apps: true,
    allow_cms: true,
};
